export default __webpack_public_path__ + "static/media/service_91.0c638562.png";